import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import DelugeFunction from "./Tabs/DelugeFunction";
import AuthenticatedUser from "./Tabs/AuthenticatedUser";
import InviteUser from "./Tabs/InviteUser";
import {
  checkServiceAuth,
  getServiceAuthUrl,
  revokeService,
  sendInvitalionLink,
} from "../../../APICalling/ServiceAPICalling";
import {
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
} from "../../../config/otherConstant";
import axios from "axios";

const ZOHO = window?.ZOHO;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserConnectionStatus({
  connectionDetails,
  setConnectionDetails,
  activeUsers,
  currentUser,
  dataCenterUrl,
  dataCenter,
  handlefetchConnections,
  orgId,
  apiKey,
  zApiKey,
  setSnack,
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInvite = async (userEmail) => {
    try {
      // https://www.zohoapis.com/crm/v2/functions/send_authentication_link/actions/execute?auth_type=oauth

      let body = {
        orgId,
        apiKey,
        zapiKey: zApiKey,
      };

      let service = {
        ...connectionDetails?.service,
        settingId: connectionDetails?.settingId,
        scope: connectionDetails?.data?.scopes
          ?.filter((socopeCheckbox) => socopeCheckbox?.value)
          ?.map((socopeCheckbox) => socopeCheckbox?.scope?.name),
        connName:
          connectionDetails?.service?.serviceConnection +
          "__" +
          connectionDetails?.data?.connApiName +
          "__" +
          userEmail,
      };

      let serviceAuthUrl = await getServiceAuthUrl(body, service);

      let func_name = "easyauthenticator__send_invitation_mail";
      // https://www.zohoapis.com/crm/v2/functions/easyauthenticator__send_invitation_mail/actions/execute?auth_type=apikey&zapikey=<zapikey>
      // config = {
      //   url: `https://www.zohoapis.com/crm/v2/functions/easyauthenticator__send_invitation_mail/actions/execute?auth_type=apikey&zapikey=${zApiKey}`,
      //   method: "post",
      //   headers: { "Content-Type": "application/json" },
      //   data: req_data,
      // };

      var req_data = {
        email: userEmail,
        url: serviceAuthUrl,
        service: service?.name,
        invitor: currentUser?.full_name,
        invitor_email: currentUser?.email,
      };
      // console.log({ req_data });

      try {
        // const invitationResp = await sendInvitalionLink({
        //   data: req_data,
        //   zApiKey: zApiKey,
        // });
        // console.log({ invitationResp });
        const invitationResp = await ZOHO.CRM.FUNCTIONS.execute(func_name, req_data);
        console.log({invitationResp});
        setSnack(
          getOpenSnakSuccessData("Success!! Mail has been sent successfully")
        );
      } catch (error) {
        setSnack(getOpenSnakErrorData());
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleRevokeUser = async (userEmail) => {
    try {
      let service = {
        ...connectionDetails?.service,
        settingId: connectionDetails?.settingId,
        scope: connectionDetails?.data?.scopes
          ?.filter((socopeCheckbox) => socopeCheckbox?.value)
          ?.map((socopeCheckbox) => socopeCheckbox?.scope?.name),
        connName:
          connectionDetails?.service?.serviceConnection +
          "__" +
          connectionDetails?.data?.connApiName +
          "__" +
          userEmail,
      };

      const serviceHeaders = {
        orgid: orgId,
        apikey: apiKey,
        connname:
          connectionDetails?.service?.serviceConnection +
          "__" +
          connectionDetails?.data?.connApiName +
          "__" +
          userEmail,
      };
      const revokeUserResp = await revokeService(serviceHeaders);

      setSnack(
        getOpenSnakSuccessData("Success!! User connection revoked successfully")
      );
      let tempConnectionDetails = connectionDetails;
      tempConnectionDetails["users"] = tempConnectionDetails?.users?.filter(
        (email) => email != userEmail
      );
      setConnectionDetails((prev) => tempConnectionDetails);
    } catch (error) {}
  };

  const handleCheckUserAuthStatus = async (userEmail) => {
    try {
      const serviceHeaders = {
        orgid: orgId,
        apikey: apiKey,
        connname:
          connectionDetails?.service?.serviceConnection +
          "__" +
          connectionDetails?.data?.connApiName +
          "__" +
          userEmail,
      };
      const checkAuthResp = await checkServiceAuth(serviceHeaders);
      console.log({ checkAuthResp });
      if (checkAuthResp) {
        return setSnack(
          getOpenSnakSuccessData("Success!!! User is connected.")
        );
      }
      return setSnack(getOpenSnakErrorData("Error!!! User is not connected."));
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="User Status" {...a11yProps(0)} />
          <Tab label="Deluge Code" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <AuthenticatedUser
        value={value}
        index={0}
        connectionDetails={connectionDetails}
        activeUsers={activeUsers}
        orgId={orgId}
        apiKey={apiKey}
        dataCenterUrl={dataCenterUrl}
        dataCenter={dataCenter}
        zApiKey={zApiKey}
        setSnack={setSnack}
        currentUser={currentUser}
        handleInvite={handleInvite}
        handleRevokeUser={handleRevokeUser}
        handleCheckUserAuthStatus={handleCheckUserAuthStatus}
        handlefetchConnections={handlefetchConnections}
      />

      <DelugeFunction
        value={value}
        index={1}
        orgId={orgId}
        connectionDetails={connectionDetails}
        currentUser={currentUser}
        zApiKey={zApiKey}
        setSnack={setSnack}
      />
    </Box>
  );
}
